export default "__VITE_ASSET__0EspI8oK__"